/**
 * @flow
 * @relayHash 961cfa9999e504d0dbff43b9674fc41f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateReferenceInput = {|
  id: string,
  title?: ?string,
  description?: ?string,
  clientMutationId?: ?string,
|};
export type UpdateReferenceMutationVariables = {|
  input: UpdateReferenceInput
|};
export type UpdateReferenceMutationResponse = {|
  +updateReference: ?{|
    +updatedReference: ?{|
      +id: string,
      +title: ?string,
      +description: ?string,
    |}
  |}
|};
export type UpdateReferenceMutation = {|
  variables: UpdateReferenceMutationVariables,
  response: UpdateReferenceMutationResponse,
|};
*/


/*
mutation UpdateReferenceMutation(
  $input: UpdateReferenceInput!
) {
  updateReference(input: $input) {
    updatedReference {
      id
      title
      description
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateReferenceInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateReference",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateReferencePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatedReference",
        "storageKey": null,
        "args": null,
        "concreteType": "ReferenceNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateReferenceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateReferenceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateReferenceMutation",
    "id": null,
    "text": "mutation UpdateReferenceMutation(\n  $input: UpdateReferenceInput!\n) {\n  updateReference(input: $input) {\n    updatedReference {\n      id\n      title\n      description\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '69a317bd61f197b67067c448d0ac015a';
module.exports = node;
